// Save a PNG of the current Three.js scene. Hides selection helpers + UI
// chrome for a clean frame, then restores everything before returning.
//
// UI chrome hide/restore goes through the store ('ui:chrome:hide' /
// 'ui:chrome:restore') so this module never knows the DOM IDs. The selection
// hover panel is hidden via 'ui:hoverTooltip:hide' for a clean frame.

import type * as THREE from 'three';
import { store } from '../store/instance';
import { INTENTS } from '../store/intents';
import type { ViewerContext } from '../app/context';

interface ToggleableObject3D extends THREE.Object3D {
    _prevVisible?: boolean;
}

export function saveScenePNG(viewer: ViewerContext): void {
    try {
        const renderer = viewer.three.renderer;
        const camera = viewer.three.camera;
        const scene = viewer.three.scene;

        const toHide3D: ToggleableObject3D[] = [];
        const sel = viewer.objects.selection;
        const candidates: (THREE.Object3D | null)[] = [sel.centerDot, sel.projectionLines, sel.wireframe, sel.cube, sel.ring];
        candidates.forEach((obj) => {
            if (obj && typeof obj.visible === 'boolean') {
                const t = obj as ToggleableObject3D;
                toHide3D.push(t);
                t._prevVisible = t.visible;
                t.visible = false;
            }
        });

        store.dispatch(INTENTS.UI_CHROME_HIDE);
        store.dispatch(INTENTS.UI_HOVER_HIDE);
        try { if (renderer && scene && camera) renderer.render(scene, camera); } catch { /* swallow */ }

        const dataUrl = renderer && renderer.domElement ? renderer.domElement.toDataURL('image/png') : null;
        if (dataUrl) {
            const a = document.createElement('a');
            const t = new Date();
            const pad = (n: number): string => (n < 10 ? '0' + n : '' + n);
            const name = `scene_${t.getFullYear()}${pad(t.getMonth() + 1)}${pad(t.getDate())}_${pad(t.getHours())}${pad(t.getMinutes())}${pad(t.getSeconds())}.png`;
            a.href = dataUrl;
            a.download = name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        store.dispatch(INTENTS.UI_CHROME_RESTORE);
        toHide3D.forEach((obj) => {
            try {
                obj.visible = (typeof obj._prevVisible === 'boolean') ? obj._prevVisible : obj.visible;
                delete obj._prevVisible;
            } catch { /* swallow */ }
        });
        try { if (renderer && scene && camera) renderer.render(scene, camera); } catch { /* swallow */ }
    } catch (e) {
        console.warn('Failed to save PNG:', e);
    }
}
